import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PosthogService from './utils/tracking_utils';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { InterviewManager } from './questions/interview_manager';
import { PremiumHome } from './premium/premium_home';
import { ViewInterviewEvaluation } from './questions/view_interview_evaluation';
import { ViewPastInterviews } from './questions/view_past_interviews';
import { DSAInterviewSetsTable } from './dsa/all_interview_sets';
import { AllCompanyRoadmaps } from './other_pages/company_roadmaps';
import { CompanyQuestionsTable } from './questions_list/company_questions_table';
import { AboutMockGym } from './other_pages/about_mockgym';
//import reportWebVitals from './reportWebVitals';

//PosthogService.init()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Routes>
    <Route exact path="/" element={<App />} />
    <Route exact path="/question/:questionId" element = {<InterviewManager />} />
    <Route exact path="/lld/:companyCode" element = {<CompanyQuestionsTable />} />
       
    <Route exact path="/evaluations/:interviewId" element = {<ViewInterviewEvaluation />} />
    <Route exact path="/evaluations/" element = {<ViewPastInterviews />} />
    <Route exact path="/premium" element={<PremiumHome />} />
    
    <Route exact path="/dsa/:companyCode" 
      element = {<DSAInterviewSetsTable />} />
    <Route exact path="/dsa/" 
      element = {<DSAInterviewSetsTable />} />
    
    <Route exact path="/roadmaps/:companyCode" 
      element = {<AllCompanyRoadmaps />} />
    <Route exact path="/roadmaps/" 
      element = {<AllCompanyRoadmaps />} />
    <Route exact path="/about" element={<AboutMockGym />} />

  </Routes>
</BrowserRouter>
 
);

{/*
  <Route exact path="/about" element={<AboutWebsite />} />
   <React.StrictMode>
    <App />
  </React.StrictMode>
  */}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
